import { computed } from 'vue';
import { CentralSystem as CentralSystemApi, searchCentralSystems } from '@infuse/api/e-connector/central-system';
import { mapToDomain } from '@infuse/e-connector/central-system/domain';
import { usePageableResource } from '@infuse/e-connector/shared/queries';

export const useCentralSystems = (pageSize = 20) => {
  const SEARCHABLE_FIELDS = ['name'];

  const query = usePageableResource<CentralSystemApi>(searchCentralSystems, {
    queryKey: 'central-systems',
    searchableFields: SEARCHABLE_FIELDS,
    pageSize
  });

  const centralSystems = computed(
    () => query.data.value?.pages.flatMap((page) => page.content?.map((cs) => mapToDomain(cs))) || []
  );

  return {
    ...query,
    centralSystems
  };
};
